import { useEffect } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "./components/ui/sonner";
import { ContentProvider } from "./lib/content";
import { SmoothScroll } from "./components/site/SmoothScroll";
import { ConsentBanner } from "./components/site/ConsentBanner";
import Home from "./pages/Home";
import GetStarted from "./pages/GetStarted";
import ThankYou from "./pages/ThankYou";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import Admin from "./pages/Admin";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) el.scrollIntoView({ block: "start" });
      }, 120);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    return undefined;
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <ContentProvider>
        <BrowserRouter>
          <SmoothScroll />
          <ScrollManager />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/get-started" element={<GetStarted />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <ConsentBanner />
          <Toaster theme="dark" position="bottom-center" />
        </BrowserRouter>
      </ContentProvider>
    </MotionConfig>
  );
}

export default App;
